// extracted by mini-css-extract-plugin
export var imgbox = "styles-module--imgbox--67786";
export var navigation = "styles-module--navigation--41721";
export var overlapbox = "styles-module--overlapbox--fa6b7";